import React from 'react';
import { CollectionListProductItem } from './CollectionListProductItem';
import { Box, styled } from '@mui/material';
import useProductStocksSWR from '../../hooks/products/useProductStocks';
import { getShopifyID } from '../../utils/utils';
import { Product } from '../../models/Product';

const CollectionItemWrapper = styled(Box)(({ theme }) => ({
    paddingBottom: '20px',
}));

export const CollectionListWrapper = (props: any) => {
    const { products, handle } = props;
    const { stocks, isLoading, isError, getDefaultStock } =
        useProductStocksSWR(products);

    return (
        <Box>
            {products.map((item) => {
                const defaultStock =
                    stocks &&
                    stocks.find(
                        (elem) =>
                            elem.productId.toString() == getShopifyID(item.id)
                    );

                return (
                    <CollectionItemWrapper key={item.id}>
                        <CollectionListProductItem
                            product={item}
                            handle={handle}
                            productQuantity={
                                defaultStock &&
                                getDefaultStock(
                                    defaultStock.locations,
                                    getShopifyID(item.variants.nodes[0].id)
                                )
                            }
                        />
                    </CollectionItemWrapper>
                );
            })}
        </Box>
    );
};

type ListProps = {
    products: Product[];
    handle: string;
};
